import './Tag.scss'
import React from 'react'
import PropTypes from 'prop-types'

const Tag = ({ variant = 'default', color = 'default', children }) =>
  <div className={ `widget-typography-tag ${ variant } color-${ color }` }>
    { children }
  </div>

Tag.propTypes = {
  variant: PropTypes.oneOf(['sponsored', 'default']),
  color: PropTypes.oneOf(['default', 'light-mobile']),
}

export default Tag
